import { SiteLink } from '../components/site-link';
import { useTranslation } from 'react-i18next';
import { useUrlLocale } from '../i18n/url-locale';
import { appLinks, buildConfig } from '../lib/config';
import { useReferral } from '../lib/referral-context';
import { getGetStartedContent } from '../lib/content';
import { usePageTitle } from '../lib/use-page-title';

/**
 * Where "Get started" and "Sign in" lead. Without APP_ORIGIN the app is not
 * open to the public, and this page says so plainly instead of linking to a
 * domain that does not answer.
 */
export function GetStartedPage() {
  const { t } = useTranslation();
  const locale = useUrlLocale();
  const page = getGetStartedContent(locale);
  const links = appLinks(buildConfig, locale, useReferral());
  usePageTitle('/get-started', page.meta.title);
  return (
    <div className="container page narrow">
      <h1>{page.headline}</h1>
      {links.available ? (
        <section className="card" aria-labelledby="available-title">
          <h2 id="available-title">{page.available.title}</h2>
          <p>{page.available.body}</p>
          <div className="actions">
            <a className="button button-primary" href={links.signup}>
              {page.available.signupLabel} <span className="visually-hidden">{t('getStarted.external')}</span>
            </a>
            <a className="button button-secondary" href={links.login}>
              {page.available.loginLabel} <span className="visually-hidden">{t('getStarted.external')}</span>
            </a>
          </div>
        </section>
      ) : (
        <section className="card notice" aria-labelledby="unavailable-title">
          <h2 id="unavailable-title">{page.unavailable.title}</h2>
          <p>{page.unavailable.body}</p>
          <SiteLink className="button button-primary" to="/contact">
            {page.unavailable.contactCtaLabel}
          </SiteLink>
        </section>
      )}
    </div>
  );
}
